import axios from 'store/axios/axios-crm';
import { handleError } from '../../../shared/utility';

export const getCRMHistory = async (crmType, entityId) => {
    try {
        let query = '';
        if (crmType === 'contact') {
            query = `/crm_history?type=contact&id=${entityId}`;
        }
        if (crmType === 'company') {
            query = `/crm_history?type=company&id=${entityId}`;
        }
        if (crmType === 'property') {
            query = `/crm_history?type=property&id=${entityId}`;
        }
        const response = await axios.get(query);
        console.log('history data ->', response.data);
        return response.data;
    } catch(e) {
        handleError(e);
    }
    return null;
}

export const transformFiles = (arr) => {
    let val = '0 files';
    try {
        const files = arr ? 
            JSON.parse(arr)
        : 
            [];
        if (files.length !== 0) {
            val = `${files.length} file(s) ${files.length > 0 ? `-` : ``} ${files.map(f => {
                return `Filename: ${f.filename} ${f.description ? `- Description: ${f.description}` : ``}`;
            }).join(', ')}`
        }
    } catch(e) {
        console.log('error');
    }
    return val;
}